import Form from "ui/atom/Form";
import Button from "ui/base/Button";
import Card from "ui/base/Card";
import Page from "ui/Page";

import { ApplicationStatus } from "api/models/partner";

import { usePartner, usePaywall } from "../fabric";
import Box from "ui/atom/Box";
import Alert from "@mui/material/Alert";


export default function Partner() {
	const { back, form, cms, currencies, mutation } = usePartner();

	const style = {
		success: {
			display: mutation.isSuccess ? "flex" : "none",
			transition: "all 500ms ease"
		},
		error: {
			display: mutation.error ? "flex" : "none",
			transition: "all 500ms ease"
		}
	} as SxProps;

	return (
		<Page maxWidth="sm">
			<Page.Body>
				<Alert id="success-alert" variant="filled" color="success" severity="success" sx={style.success}>
					Partner updated
				</Alert>
				<Alert id="error-alert" variant="filled" color="error" severity="error" sx={style.error}>
					{mutation.error?.message}
				</Alert>
				<Card>
					<Card.Header title="Partner" />
					<Card.Content>
						<Form>
							<form.AppForm>
								<Form.Row wrap>
									<form.AppField name="partner.logo.light" children={(field) => <field.Image label="Light Logo" dark />} />
									<form.AppField name="partner.logo.dark" children={(field) => <field.Image label="Dark Logo " />} />
									<form.AppField name="partner.logo.logomark" children={(field) => <field.Image label="Logo Mark" />} />
								</Form.Row>
								<form.AppField name="partner.name" children={(field) => <field.Input label="Name" />} />
								<form.AppField name="partner.url" children={(field) => <field.Input label="Url" />} />
								<form.AppField name="partner.status" children={(field) => <field.Enum enumType={ApplicationStatus} label="Status" />} />
								<Form.Row>
									<form.AppField name="partner.cmsId" listeners={{ onChange: () => form.setFieldValue("partner.paywallId", "") }} children={(field) => <field.Select label="CMS" options={cms.data} />} />
									<form.Subscribe selector={(state) => state.values.partner.cmsId}>
										{(cmsId) => {
											const paywalls = usePaywall(cmsId);
											return <form.AppField name="partner.paywallId" children={(field) => <field.Select options={paywalls.data} disabled={!cmsId} label="Paywall" />} />;
										}}
									</form.Subscribe>
								</Form.Row>
								<form.AppField name="partner.payoutCurrencyId" children={(field) => <field.Select label="Currency" options={currencies.data} />} />

								<Form.Section title="Contact Information">
									<form.AppField name="contact.name" children={(field) => <field.Input label="Name" />} />
									<form.AppField name="contact.email" children={(field) => <field.Input label="Email" type="email" />} />
									<form.AppField name="contact.phone" children={(field) => <field.Phone label="Phone" type="tel" />} />
									<form.AppField name="contact.company" children={(field) => <field.Input label="Organization Name" />} />
								</Form.Section>

								<form.Subscribe>
									<Box gap={1} sx={{ mt: 2 }}>
										<Button variant="contained" color="error" onClick={back} fullWidth>Cancel</Button>
										<Button variant="contained" color="success" onClick={form.handleSubmit} fullWidth>Save</Button>
									</Box>
								</form.Subscribe>
							</form.AppForm>
						</Form>
					</Card.Content>
				</Card>
			</Page.Body>
		</Page>
	);
}